import * as React from "react";
import { RefObject } from "react";
import { v7 as uuidv7 } from "uuid";
import AsyncAction from "../../AsyncAction";
import { MouthType, PhotoSet, PhotoSetStatus } from "../../troubleshoot/ReportTroubleshoot";
import PhotoSetStatusViewer from "./PhotoSetStatusViewer";
import sfetch from "../utils/super-fetch";
import { dateWithOptionalTime } from "../utils/date";

interface ScanPackageViewerProps {
  mouthType: MouthType;
  photoSet: PhotoSet;
  uploadUrl?: string;
  displayAllRejectionCauses: boolean;
}

export default class ScanPackageViewer extends React.PureComponent<ScanPackageViewerProps> {
  private inputRef: RefObject<HTMLInputElement> = React.createRef();
  private asyncActionRef: RefObject<AsyncAction> = React.createRef();

  render() {
    const photosAvailable = !!this.props.photoSet.photos.length;
    return (
      <div className={"scan-package-viewer" + (photosAvailable ? " vertical-dropdown" : "")}>
        <div
          className={
            (photosAvailable ? "vertical-dropdown-toggle " : "") +
            "h-flex space-between align-center"
          }
        >
          <div>
            <div>{i18n[getI18nMouthType(this.props.mouthType)]}</div>
            {this.props.photoSet.date && (
              <div className="small">
                {
                  i18n[
                    getI18nStatus(
                      this.props.photoSet.status === PhotoSetStatus.REJECTED
                        ? PhotoSetStatus.REJECTED
                        : PhotoSetStatus.RECEIVED
                    )
                    ]
                }
                {dateWithOptionalTime(this.props.photoSet.date)}
              </div>
            )}
            <PhotoSetStatusViewer
              status={this.props.photoSet.status}
              className="small"
              detail={this.props.photoSet.detail}
              displayAllRejectionCauses={this.props.displayAllRejectionCauses}
            />
          </div>
          <div className="h-flex align-center with-margins">
            {this.props.uploadUrl && (
              <div>
                <input
                  ref={this.inputRef}
                  type="file"
                  className="none"
                  onChange={this.onFileSet.bind(this)}
                />
                <AsyncAction
                  ref={this.asyncActionRef}
                  buttonLabel=""
                  onClick={(e) => {
                    e.preventDefault();
                    this.inputRef.current.click();
                  }}
                  fontIcon="ic_upload"
                  promise={this.uploadScanPackage.bind(this)}
                  onSuccess={() => location.reload()}
                  onError={() => {
                    this.inputRef.current.value = "";
                    alert("An error occurred!");
                  }}
                />
              </div>
            )}
            {photosAvailable && (
              <div className="text-action">
                <i className="ic_chevron_down" />
              </div>
            )}
          </div>
        </div>
        {photosAvailable && (
          <div className="container-vertical-dropdown">
            <div className="photo-grid">
              {this.props.photoSet.photos.map((p) => (
                <img key={p.uid} src={p.href} alt="photo" />
              ))}
            </div>
          </div>
        )}
      </div>
    );
  }

  uploadScanPackage() {
    const body = new FormData();
    body.append("data", this.inputRef.current.files[0]);
    return sfetch(this.props.uploadUrl + `?mouth=${this.props.mouthType}`, {
      body,
      method: "POST",
      headers: { "X-Idempotency-Token": uuidv7() },
    });
  }

  onFileSet() {
    if (this.inputRef.current.files[0]) {
      this.asyncActionRef.current.performAsyncAction();
    }
  }
}

const getI18nMouthType = (mouthType: MouthType) => {
  switch (mouthType) {
    case MouthType.CLOSED:
      return "MouthType.Closed";
    case MouthType.SLIGHTLY_OPENED:
      return "MouthType.SlightlyOpened";
    case MouthType.OPENED:
      return "MouthType.Opened";
  }
};

const getI18nStatus = (status: PhotoSetStatus) => {
  switch (status) {
    case PhotoSetStatus.RECEIVED:
      return "PhotoSet.Status.Received";
    case PhotoSetStatus.REJECTED:
      return "PhotoSet.Status.Rejected";
  }
};
